<template>
    <div class="app-wrapper">

        <navbar :navData="navData" />

        <app-main />

        <page-footer />

    </div>

</template>

<script>
import page from "./index.js";
export default page;
</script>

<style>
@import "./index.css";
</style>


// WEBPACK FOOTER //
// src/layout/app/index.vue